import { Injectable } from '@angular/core';

/**
 * Service to calculate reading time for blog posts
 * Uses average reading speed of 200 words per minute
 */
@Injectable({
  providedIn: 'root'
})
export class ReadingTimeService {
  private readonly WORDS_PER_MINUTE = 200;

  constructor() { }

  /**
   * Calculate reading time in minutes from blog content
   * @param content - The blog post content (HTML or text)
   * @returns Reading time in minutes (minimum 1)
   */
  calculateReadingTime(content: string): number {
    if (!content) {
      return 1;
    }

    // Strip HTML tags if content contains HTML
    const plainText = this.stripHtmlTags(content);
    
    // Count words by splitting on whitespace
    const wordCount = plainText.trim().split(/\s+/).length;
    
    // Calculate reading time
    const readingTime = Math.ceil(wordCount / this.WORDS_PER_MINUTE);
    
    // Return minimum 1 minute
    return Math.max(1, readingTime);
  }

  /**
   * Strip HTML tags from content
   * @param html - HTML content
   * @returns Plain text content
   */
  private stripHtmlTags(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  /**
   * Format reading time for display
   * @param minutes - Reading time in minutes
   * @returns Formatted string like "5 min read"
   */
  formatReadingTime(minutes: number): string {
    return `${minutes} min read`;
  }
}
